module.exports = __webpack_public_path__ + "static/media/caskshare-raffle-ticket.b1a6e3f5.png";